<template>
  <div class="search">
    <Spin v-if="loading" fix />
    <div class="bodys">
      <keep-alive :include="['search-mobile-apply', 'search-mobile-register']">
        <MyApply
          v-if="step === 1"
          :selection="selection"
          :maxSelect="maxSelect"
          @on-select="addApply"
          @on-select-cancel="delApply"
        />
        <MyRegister
          ref="myRegister"
          v-if="step === 2"
          :formItems.sync="formItems"
          :formData.sync="formData"
          :uploadList.sync="uploadList"
        />
      </keep-alive>
    </div>
    <div class="footer">
      <div class="operate" @click="openSelection">
        <span>{{ `已选工程(${selection.length})` }}</span>
        <Icon type="ios-arrow-down" />
      </div>
      <div class="empty"></div>
      <div class="operate" v-if="step > 1" @click="prev">
        <Icon type="ios-arrow-back" />
        <span>上一步</span>
      </div>
      <div class="operate" v-if="step === 1" @click="next">
        <span>预约登记</span>
        <Icon type="ios-arrow-forward" />
      </div>
      <div class="operate" v-else @click="doSubmit">
        <span>提交</span>
      </div>
    </div>
    <MyDrawer v-model="drawer">
      <div class="drawer">
        <p class="title">已选工程</p>
        <div class="item" v-for="s in selection" :key="s.SID">
          <span>{{ s.ENG_NAME }}</span>
          <Icon type="ios-close-circle" @click="delApply(s)" />
        </div>
      </div>
    </MyDrawer>
  </div>
</template>

<script>
import MyApply from './apply'
import MyDrawer from './drawer'
import MyRegister from './register'
import { PostSubscribe } from '@api'
export default {
  name: 'search-mobile',
  components: { MyApply, MyDrawer, MyRegister },
  data () {
    return {
      loading: false,
      drawer: false,
      selection: [],
      step: 1,
      formItems: [],
      formData: {},
      uploadList: [],
      maxSelect: 80
    }
  },
  methods: {
    addApply (row) {
      this.selection.push(row)
      if (this.selection.length >= this.maxSelect) {
        this.$Message.warning(`最多只能申请${this.maxSelect}条`)
      }
    },
    delApply (row) {
      const index = this.selection.findIndex(f => f.SID === row.SID)
      index > -1 && this.selection.splice(index, 1)
      !this.selection.length && (this.drawer = false)
    },
    prev () {
      this.step--
    },
    next () {
      if (!this.selection.length) {
        this.$Message.warning('请至少选择一项需要查阅的工程')
        return
      }
      this.$Modal.confirm({
        title: '提示',
        content: window.config.disclaimer,
        onOk: () => { this.step++ }
      })
    },
    openSelection () {
      if (!this.selection.length) {
        this.$Message.warning('请至少选择一项需要查阅的工程')
        return
      }
      this.drawer = true
    },
    async doSubmit () {
      this.loading = true
      try {
        const validate = await this.$refs['myRegister'].validate()
        if (!this.selection.length) {
          const msg = '请至少选择一项需要查阅的工程'
          this.$Message.warning(msg)
          throw msg
        }
        if (validate) {
          let query = {}
          query.CDType = 1
          query.ArchiveIDS = this.selection.map(m => m.SID).join(',')
          query.UploadFiles = this.uploadList.map(m => {
            if (!m.files.length) {
              const msg = `${m.title} 未上传照片`
              this.$Message.warning(msg)
              throw msg
            }
            return {
              FileType: m.type,
              FileContent: m.title,
              FileName: m.files.map(f => f.response.split('/').pop())
            }
          })
          query = Object.assign(this.formData, query)
          const { data: { Code, Msg } } = await PostSubscribe(query)
          if (!Code) {
            this.$Modal.success({
              title: '提示',
              content: '您的查档信息登记成功。工作日24小时内审核，审核结果自动发送，请留意邮箱。（法定节假日不受理）',
              onOk: () => { this.doConfirm() }
            })
          } else {
            this.$Message.error(Msg || '提交失败')
          }
        }
      } catch (e) {
        console.error(e)
      }
      this.loading = false
    },
    doConfirm () {
      window.location.reload()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@theme/globle.scss';
.search {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
}
.bodys {
  width: 100%;
  flex: 1;
  overflow-y: auto;
  &>div {
   width: 100%;
   height: 100%;
  }
}
.footer {
  height: 50px;
  background: $default;
  position: relative;
  display: flex;
  align-items: center;
  .empty {
    flex: 1;
  }
  .operate {
    min-width: 100px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    color: #fff;
    padding: 0 16px;
    span {
      vertical-align: middle;
    }
    i {
      margin: 0 6px;
      font-size: 20px;
      vertical-align: middle;
    }
  }
}
.drawer {
  .title {
    height: 48px;
    line-height: 48px;
    padding: 0 16px;
  }
  .item {
    margin: 6px 0;
    padding: 0 16px;
  }
  .item {
    font-size: 16px;
    display: flex;
    align-items: center;
    span {
      flex: 1;
    }
    i {
      color: $error;
      font-size: 28px;
    }
  }
}
</style>